module.exports = __webpack_public_path__ + "static/media/n-it_4.4d4b043e.png";